/**
 * @generated SignedSource<<153b61b3df8877a2910b0f3bcd512712>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PreMeetingControls_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AutoRecordToggle_viewer" | "OptionsMenu_viewer">;
  readonly " $fragmentType": "PreMeetingControls_viewer";
};
export type PreMeetingControls_viewer$key = {
  readonly " $data"?: PreMeetingControls_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PreMeetingControls_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PreMeetingControls_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AutoRecordToggle_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OptionsMenu_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "23ddc23a437cf76eaa7237afaeb980b7";

export default node;
